import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["^href"]
const _hoisted_2 = ["innerHTML"]

import { convertMarkdown } from "@/markdown/util/markdown.util";
import { Note } from "@/models/note";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NoteCard',
  props: {
  note: {
    type: Object as PropType<Note>,
    required: true
  }
},
  setup(__props) {

const { note } = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("a", {
      "^href": `/note/${__props.note.id}`
    }, [
      _createElementVNode("h3", null, _toDisplayString(__props.note.title), 1)
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      innerHTML: _unref(convertMarkdown)(__props.note.description)
    }, null, 8, _hoisted_2)
  ]))
}
}

})